export default [
  {
    position: "absolute",
    top: 12.2,
    left: 82,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-top-right",
    isDialog: true,
    modal: false,
    mTitle: "adamP3.mTitleOne",
    mBody: "adamP3.mBodyOne",
    isVideo: true,
    videoThumb: "HR-Adam-Thumb",
    videoURL: "HR-Adam.mp4",
    vidIcon: true,
    id: "HR_AdamGibson_Video_UploadingDocuments",
    index: 0,
  },
  {
    position: "absolute",
    top: 39.5,
    left: 82,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-right",
    isDialog: true,
    modal: false,
    mTitle: "adamP3.mTitleTwo",
    mBody: "adamP3.mBodyTwo",
    id: "HR_AdamGibson_Info_EmploymentRecord",
    infoIcon: true,
    isAction: false,
    index: 1,
  },
  {
    position: "absolute",
    top: 1.6,
    left: 12,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 0,
    tooltipText: "adamP3.ttTextOne",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_AdamGibson_Navigation_Home",
    index: 2,
  },
  {
    position: "absolute",
    top: 1.6,
    left: 27.9,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 1,
    tooltipText: "adamP3.ttTextFour",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_AdamGibson_Navigation_TeamMembers",
    index: 3,
  },
  {
    position: "absolute",
    top: 1.6,
    left: 34.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 5,
    tooltipText: "adamP3.ttTextThree",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_AdamGibson_Navigation_Dashboards",
    index: 4,
  },
  {
    position: "absolute",
    top: 1.6,
    left: 39.2,
    class: "tooltips",
    animation: "pulsing",
    isTooltip: true,
    navPos: 3,
    tooltipText: "adamP3.ttTextTwo",
    hover: false,
    tooltipClass: "bottom",
    id: "HR_AdamGibson_Navigation_Reports",
    index: 5,
  },
  {
    position: "absolute",
    top: 33.5,
    left: 51,
    class: "dialog",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "adamP3.formulaFieldsTitle",
    mBody: "adamP3.formulaFieldsBody",
    id: "HR_AdamGibson_Formula_Fields",
    infoIcon: true,
    isAction: false,
    index: 6,
  },
  {
    position: "absolute",
    top: 24.2,
    left: 81,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-top-right",
    isDialog: true,
    modal: false,
    mTitle: "adamP3.multiNationalPoliciesTitle",
    mBody: "adamP3.multiNationalPoliciesBody",
    isVideo: true,
    videoThumb: "HR-Multinational-Policies-Thumb",
    videoURL: "HR-Multinational-Policies.mp4",
    vidIcon: true,
    id: "HR_AdamGibson_Video_MultiNationalPolicies",
    index: 7,
  },
  {
    position: "absolute",
    top: 6.6,
    left: 31.5,
    class: "video",
    animation: "pulsing",
    modalClass: "modal-top-left",
    isDialog: true,
    modal: false,
    mTitle: "adamP3.flexibleCustomizationTitle",
    mBody: "adamP3.flexibleCustomizationBody",
    isVideo: true,
    videoThumb: "HR-Flexible-Customization-Thumb",
    videoURL: "HR-Flexible-Customization.mp4",
    vidIcon: true,
    id: "HR_AdamGibson_Video_Flexible_customization",
    index: 8,
  },
];
